import script from "./Infographics.vue?vue&type=script&setup=true&lang=ts"
export * from "./Infographics.vue?vue&type=script&setup=true&lang=ts"

import "./Infographics.vue?vue&type=style&index=0&id=0e35fa96&lang=css"
import "./Infographics.scss?vue&type=style&index=1&id=0e35fa96&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e35fa96"]])

export default __exports__